<template>
  <div class="stack">
    <div class="stack__box">
      <header class="stack__box__header">
        <ui-button
          class="stack__box__header__close"
          @click.prevent="toggleStackPopUp(false)"
          button="secondary"
          :label="$t('commons.buttons.close')"
          :icon-only="true"
          icon="close"
        />
        <div class="stack__box__header__title">
          {{ $t('stacks.title') }}
        </div>
      </header>
      <div class="stack__box__container" v-if="!refreshingData">
        <div class="stack__box__container__section">
          <ui-radio
            class="stack__box__container__section__radio"
            :id="`brand-${n}`"
            v-for="(n, index) in maxLevel"
            :key="'level ' + index"
            v-model="model"
            :value="n"
          >
            <span class="stack__box__container__section__radio__label">
              <span class="stack__box__container__section__radio__label__name">
                {{ $t(`stacks.level-${n}`) }}
              </span>
            </span>
          </ui-radio>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { isMobile } from '@/utils/navigator.util'
import UiButton from '@/components/UI/Button.vue'
import UiRadio from '@/components/UI/Radio.vue'

export default {
  name: 'GmapStack',
  components: {
    UiButton,
    UiRadio,
  },
  props: {},
  data() {
    return {
      isMobile: isMobile(),
      maxLevel: 1,
    }
  },
  computed: {
    ...mapState({
      settings: state => state.data.settings,
      subDivisions: state => state.data.subDivisions,
      refreshingData: state => state.radar.refreshing.data,

      currentCountries: state => state.refine.currentCountries,
    }),
    model: {
      get() {
        return parseInt(this.$route.query.level) || 2
      },
      set(value) {
        this.toggleStackPopUp(false)
        this.$router.replace({
          name: 'zones',
          params: this.$route.params,
          query: { ...this.$route.query, level: value },
        })
      },
    },
  },
  methods: {
    ...mapActions({
      toggleStackPopUp: 'radar/toggleStackPopUp',
      toggleRefreshData: 'radar/toggleRefreshData',
      toggleRefreshZones: 'radar/toggleRefreshZones',
    }),
  },
  async created() {
    let maxLevel = 1
    await this.currentCountries.forEach(currentCountrie => {
      this.subDivisions.review.subdivisions.forEach(subDivision => {
        if (currentCountrie === subDivision.key) {
          subDivision.max_level > maxLevel ? (maxLevel = subDivision.max_level) : false
        }
      })
    })
    this.maxLevel = parseInt(maxLevel)
    this.toggleRefreshData(false)
  },
}
</script>

<style lang="scss" scoped>
.stack {
  @include wrapper(flex-end);

  @media (min-width: $screen-sm) {
    @include wrapper(
      $justify: flex-start,
      $padding: $gutter-md $gutter-md calc(#{$gutter-md} * 2 + #{$button-min-height-desktop}) 0
    );

    bottom: initial;
    left: $gutter-md;
    width: calc(#{$gmap-sidebar-width-tablet} + #{$gutter-md});
  }

  @media (min-width: $screen-lg) {
    width: calc(#{$gmap-sidebar-width-desktop} + #{$gutter-md});
  }

  &__box {
    @include box;

    width: $gmap-sidebar-width-mobile;

    @media (min-width: $screen-sm) {
      width: $gmap-sidebar-width-tablet;
    }

    @media (min-width: $screen-lg) {
      width: $gmap-sidebar-width-desktop;
    }

    &__header {
      @include header;

      &__close {
        @include close;
      }

      &__title {
        @include title;
      }
    }

    &__container {
      padding: $gutter-sm;
      overflow: auto;

      @media (min-width: $screen-sm) {
        padding: $gutter-md;
      }

      &__section {
        &__radio {
          margin-bottom: 10px;
          width: 100%;

          &:last-child {
            margin-bottom: 0;
          }

          &__label {
            display: flex;
            justify-content: space-between;

            &__name {
              display: flex;
              align-items: center;
            }
          }
        }
      }
    }
  }
}
</style>
